/** Expéditeur → destinataire d'un colis, d'après le fichier du transporteur. */
export const sansAccents = (s) => (s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toUpperCase();

export function correspond(c, recherche) {
  if (!recherche) return false;
  const r = sansAccents(recherche).trim();
  const num = r.replace(/\s/g, "");
  // n° scanné, ou n° du fichier (identifiant TNT 116… d'un colis FedEx)
  if (num.length >= 3 && /^\d+$/.test(num)) return c.numero.includes(num) || !!c.info?.numero?.includes(num);
  const i = c.info;
  return !!i && (sansAccents(i.expediteur?.rs).includes(r) || sansAccents(i.destinataire?.rs).includes(r));
}

export function InfoFichier({ info, compact = false, recherche = "", numero = null }) {
  if (!info) return null;
  const e = info.expediteur || {};
  const d = info.destinataire || {};
  const r = sansAccents(recherche).trim();
  const fort = (rs) => (r && /\D/.test(r) && sansAccents(rs).includes(r) ? "bg-red-500/20 rounded px-0.5" : "");
  return (
    <div className={`text-xs leading-snug ${compact ? "" : "mt-1"}`} data-testid="info-fichier">
      <p><span className="text-muted-foreground">Exp. </span><span className={`font-medium ${fort(e.rs)}`}>{e.rs || "—"}</span>{e.ville ? <span className="text-muted-foreground"> · {e.cp} {e.ville}</span> : null}</p>
      <p><span className="text-muted-foreground">Dest. </span><span className={`font-semibold ${fort(d.rs)}`}>{d.rs || "—"}</span>{d.ville ? <span className="text-muted-foreground"> · {d.cp} {d.ville}</span> : null}</p>
      {!compact && (d.ad1 || d.ad2) && <p className="text-muted-foreground">{[d.ad1, d.ad2].filter(Boolean).join(", ")}</p>}
      {numero && info.numero && info.numero !== numero && (
        <p className="text-[11px] text-muted-foreground" data-testid="info-rapprochement">Dans le fichier sous le n° <span className="font-mono">{info.numero}</span></p>
      )}
    </div>
  );
}
